const SELECTOR = '[data-toggle="tooltip"]';

class Tooltips {
  constructor() {
    $('body').tooltip({
      selector: SELECTOR,
      trigger: 'hover',
      viewport: 'body'
    });
  }
}

export default Tooltips;



// WEBPACK FOOTER //
// ./src/javascripts/Tooltips.js